import React, { Component } from 'react';

class CartSidebar extends Component {
	handleClick = (link) => {
		this.props.handleCartClose();
		this.props.history.push(link);
	};
	render() {
		const { cartWidth, cartData } = this.props;
		const noOfItems =
			cartData && cartData.products && Object.keys(cartData.products).length
				? Object.keys(cartData.products).length
				: 0;

		return (
			<div className="cart-sidebar-section" style={{ width: cartWidth }}>
				<div className="cart-sidebar-title-section d-flex flex-row align-items-center justify-content-between">
					<div className="d-flex flex-row align-items-center">
						<p className="title m-0">My cart</p>

						{noOfItems > 0 && (
							<p className="ml-3 m-0 mt-md-1" style={{ fontWeight: '600' }}>
								<span>{noOfItems} item(s)</span>
							</p>
						)}
					</div>
					<div onClick={this.props.handleCartClose} className="close-icon pointer">
						<i className="fa fa-close" />
					</div>
				</div>

				<div className="cart-sidebar-content-section">
					<div className="details">
						{noOfItems > 0 ? (
							<div className="item-details">
								<div className="subtotal-section">
									<div className="d-flex align-items-center justify-content-between">
										<h6 className="m-0 mb-1">Sub Total</h6>
										<h6 className="m-0 mb-1">₹{cartData.cart_total}</h6>
									</div>
									<div className="d-flex align-items-center justify-content-between">
										<p className="m-0">Delivery Charges</p>
										<p className="m-0 light-green">**</p>
									</div>
								</div>
								<div className="items">
									{cartData &&
									cartData.products &&
									Object.keys(cartData.products).length > 0 && (
										<div className="items-list">
											{Object.keys(cartData.products).map((key, index) => (
												<div className="item" key={index}>
													<img src={cartData.products[key].image} alt="" />
													<div className="d-flex flex-column w-100">
														<h6 className="title">{cartData.products[key].name}</h6>
														<span>{cartData.products[key].variant}</span>
														<div className="d-flex flex-row align-items-center justify-content-between qty-row">
															<div className="first d-flex flex-row align-items-center">
																{/* <div className="qty">
																	<select
																		className="form-control m-0"
																		defaultValue="1"
																	>
																		<option value="1">1</option>
																		<option value="1">2</option>
																		<option value="1">3</option>
																		<option value="1">4</option>
																		<option value="1">5</option>
																	</select>
																</div> */}
																<div className="qtySection d-flex align-items-center flex-row">
																	<button>
																		<i className="fa fa-minus" />
																	</button>
																	<p className="m-0 px-1">1</p>
																	<button>
																		<i className="fa fa-plus" />
																	</button>
																</div>
																<p className="m-0 mx-3 into-mark">X</p>
																<p className="m-0">₹{cartData.products[key].price}</p>
															</div>
															<div className="second">
																<p className="m-0 mr-1 total">
																	₹{cartData.products[key].price}
																</p>
															</div>
														</div>
													</div>
												</div>
											))}
										</div>
									)}
								</div>
							</div>
						) : (
							<div className="no-items">
								<img src={require('assets/imgs/noCartItems.png')} alt="righSideICON" className="" />
								<h5>No items in your cart</h5>
								<p>Looks like you haven't made your choice yet</p>
							</div>
						)}
					</div>
					<div className="bottom">
						{noOfItems > 0 ? (
							<div className="d-flex flex-column w-100 align-items-center">
								<span className="promoTxt">Promo code can be applied on payment page</span>
								<button
									className="cart-sidebar-btn d-flex align-items-center justify-content-between px-2 w-100"
									onClick={() => this.handleClick('/checkout')}
								>
									<span>Proceed to checkout</span>
									<span>₹1200</span>
								</button>
							</div>
						) : (
							<button className="cart-sidebar-btn" onClick={() => this.handleClick('/')}>
								Start shopping
							</button>
						)}
					</div>
				</div>
			</div>
		);
	}
}
export default CartSidebar;
